export default __webpack_public_path__ + "static/media/Taerra.08eb3ec8.jpg";